import { currentWallet } from '@cronos-app/wallet';
import { useQuery } from '@tanstack/react-query';
import { queryClient } from '@ui/utils/queryClient';
import { ZeroAddress } from 'ethers';

import { useCardLayer } from '../useCardContextStore';
import { getCdcDepositCardService } from './useCdcDepositCardService';

const useCdcDepositAddressKey = 'useCdcDepositAddress';

export const revalidateCdcDepositAddress = () =>
  queryClient.invalidateQueries({
    queryKey: [useCdcDepositAddressKey],
  });

export const useCdcDepositAddress = () => {
  const account = currentWallet.useAccount();
  const network = currentWallet.useDesiredNetwork();
  const layer = useCardLayer();
  return useQuery({
    queryKey: [useCdcDepositAddressKey, account, network, ZeroAddress, layer],
    queryFn: async () => {
      if (!account) throw new Error('No account');
      const addr = await getCdcDepositCardService(
        network,
        layer,
      ).getCardAddress(account);
      return addr === ZeroAddress ? null : addr;
    },
    enabled: !!account,
  });
};
